import { inject } from "@vercel/analytics";
inject();

import init from "./index.wat?init";

// load the textures
const textures = document.createElement("img");
textures.src = "/textures.avif";
textures.style.imageRendering = "pixelated";

// set up the canvas
const canvas = document.querySelector("canvas")!;

const ctx = canvas.getContext("2d")!;

// create an 8 byte data view that we can write to
const view = new DataView(new ArrayBuffer(8));

// make a decoder to read the buffer
const decoder = new TextDecoder("utf-8");

// initialize the webassembly module
init({
  // these are the required imports
  imports: {
    PI: new WebAssembly.Global({ value: "f32" }, Math.PI),
    randomState: new WebAssembly.Global(
      { value: "i32", mutable: true },
      // random 32 bit number
      Math.random() * (1 << 31),
    ),
    log: console.log,
    store(name, arg) {
      // since localStorage stores string keys and string values, the i64s have to be converted to strings first
      localStorage.setItem(name.toString(), arg.toString());
    },
    load(name) {
      // since the localStorage had a string, the value must first be retrieved then converted into a bigint to be used as an i64
      return BigInt(
        localStorage.getItem(name.toString()) ??
          // using 0 as a default if the value couldn't be found
          0,
      );
    },
    setRGBFill(color) {
      // sets the color of the shape to be the hexcode corresponding to the color
      ctx.fillStyle = "#" + (color & 0xffffff).toString(16).padStart(6, "0");
    },
    fillRect: ctx.fillRect.bind(ctx),
    fillText(text, x, y) {
      view.setBigUint64(0, text);
      const decodedText = decoder.decode(view);

      // set text font
      ctx.font = "50px monospace";

      ctx.fillText(decodedText, x, y);
    },
    fillNumber(number, x, y) {
      // set text font
      ctx.font = "50px monospace";

      ctx.fillText(number.toString(), x, y);
    },
    drawTexture(sx, sy, sw, sh, x, y, w, h) {
      ctx.drawImage(textures, sx, sy, sw, sh, x, y, w, h);
    },
    clearRect: ctx.clearRect.bind(ctx),
    resizeCanvas(width, height) {
      canvas.width = width;
      canvas.height = height;
    },
    save: ctx.save.bind(ctx),
    scale: ctx.scale.bind(ctx),
    restore: ctx.restore.bind(ctx),
    translate: ctx.translate.bind(ctx),
    rotate: ctx.rotate.bind(ctx),
  },
}).then((wasm) => {
  window.addEventListener("keydown", (e) => {
    if (e.key.length === 1) wasm.exports.keyboardHandler(e.key.charCodeAt(0));
    // 'Backspace' => BS key
    else if (e.key === "Backspace") wasm.exports.keyboardHandler(0x08);
    // 'Enter' => CR key
    else if (e.key === "Enter") wasm.exports.keyboardHandler(0x0d);
  });

  canvas.addEventListener("click", (e) => {
    // recalculated per click in case user has resized the window
    const rect = canvas.getBoundingClientRect();

    wasm.exports.clickHandler(e.clientX - rect.left, e.clientY - rect.top);
  });

  Object.assign(window, { wasm });

  let lastTime = performance.now();

  // // call the initializer
  // initializer now gets automatically called when the module is opened
  function nextTick() {
    const nextTime = performance.now();

    // call the webassembly tick function
    wasm.exports.tick(((nextTime - lastTime) * 60) / 1000);

    lastTime = nextTime;

    // schedule the next tick
    requestAnimationFrame(nextTick);
  }

  // schedule the next tick
  requestAnimationFrame(nextTick);
});
